import { useEffect } from "react";
import {
  getMultiUserPlans,
  getMultiUserPlansUrgencyAnchor,
  getMultiUserPlansUrgencyRegular,
  getPlans,
  getPlansWeb46Discount,
  getPlansUrgencyAnchor,
  getPlansUrgencyRegular,
  getMultiUserPlansWeb46Discount,
  Web46DiscountPercent,
} from "../LandingPage";
import { Web29AnchorCheckoutMode } from "../web29Offer";

// Resolves the plan for /checkout?plan=…(&isMultiUser=true) against the site
// baseline offer state (formerly web29's urgency-anchor arm): offer live or
// revived → the anchor plans (control's price ids, display-only anchor);
// offer expired → the regular (÷0.8) price ids. No coupon in any mode.
export function useCheckoutPlan(
  urgencyAnchorMode: Web29AnchorCheckoutMode | null = null,
  web46DiscountPercent?: Web46DiscountPercent
) {
    const urlParams = new URLSearchParams(window.location.search);
    const planId = urlParams.get('plan');
    const isMultiUser = urlParams.get('isMultiUser') === 'true';
    let plans;
    let familyPlan;
    if (urgencyAnchorMode === "expired") {
      plans = getPlansUrgencyRegular();
      familyPlan = getMultiUserPlansUrgencyRegular();
    } else if (web46DiscountPercent) {
      plans = getPlansWeb46Discount("", "", "", web46DiscountPercent);
      familyPlan = getMultiUserPlansWeb46Discount("", "", "", web46DiscountPercent);
    } else if (urgencyAnchorMode) {
      plans = getPlansUrgencyAnchor();
      familyPlan = getMultiUserPlansUrgencyAnchor();
    } else {
      plans = getPlans();
      familyPlan = getMultiUserPlans();
    }
    const plan = isMultiUser ? familyPlan.find((p) => p.id === planId) : plans.find((p) => p.id === planId);

    useEffect(() => {
      if (!plan || plan.isOneTime) {
        window.location.href = "/results";
      }
    }, [plan]);

    return plan;
}
